'use strict';

var ChartDashboardClassFareDirective = function ChartDashboardClassFareDirective(Chart) {
  return {
    restrict: 'E',
    template: require('../templates/chart-dashboard-class-fare.html'),
    controller: 'ChartDashboardClassFareController',
    scope: {
      screen: '@',
      mode: '@'
    },
    link: function link($scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, $scope.chartFormatters);
      $scope.renderChartDataPresent = function (data) {
        chart.yAxisLabel('% Change YOY');
        chart.render(data);
      };
      $scope.$on('cog:' + $scope.cogChannel, function (event, value) {
        $scope.onDataRepresentationChange(value.val[0]);
      });
      $scope.$on('brush-filter:filterApplied', $scope.checkVisibilityAndReload);
      $scope.setChartVisibility = function (show) {
        element.toggle(show);
      };
      $scope.$on('search-criteria:searchChangeEvent', $scope.setDefaultView);
      $scope.$on($scope.screen + '-' + $scope.mode + ':dimensionChanged', $scope.checkVisibilityAndReload);
    }
  };
};
ChartDashboardClassFareDirective.$inject = ['ChartDashboardClassFare'];
module.exports = ChartDashboardClassFareDirective;